import request from '../../util/request'
import formUtils from '../../util/formUtils'
import alertUtils from '../../util/alertUtils'
import { config } from '../../config/config'
import qs from 'qs'

export default class formApi {
  /**
   * 根据 ID 获取表结构和字段信息
   * @param key
   * @param url
   */
  static getTableFields(id) {
    if (formUtils.isNull(id)) {
      alertUtils.alertWarning('接口参数不能为空', true)
      return
    }
    return request({
      url: config.baseAPI + '/v1/form/formTableDetail?id=' + id,
      method: 'get',
    })
  }

  /**
   * 根据 ID & VERSION 保存表单详细信息
   * @param key
   * @param url
   */
  static saveFormInfo(data, headers) {
    return request({
      url: config.baseAPI + '/v1/form/saveFormDetail',
      method: 'post',
      data: qs.stringify(data),
      headers: headers,
    })
  }

  /**
   * 根据 ID & VERSION 获取表单解析json数据
   * @param id
   */
  static getFormJson(id, version) {
    if (formUtils.isNull(id) || formUtils.isNull(version)) {
      alertUtils.alertWarning('接口参数不能为空', true)
      return
    }
    return request({
      url:
        config.baseAPI +
        '/v1/form/getFormJson?id=' +
        id +
        '&version=' +
        version,
      method: 'get',
    })
  }

  /**
   * 获取所有版本的表单id和version列表
   */
  static getAllPublishedForm() {
    return request({
      url: config.baseAPI + '/v1/form/getAllPublishedForm',
      method: 'get',
    })
  }

  /**
   * 根据ID & VERSION 保存 表单输入信息
   * @param data
   */
  static saveKeyValue(data) {
    request({
      url: config.baseAPI + '/v1/form/formComit',
      method: 'post',
      data,
    }).then(() => {})
  }
}
